import React, { useState } from 'react'

const Contact = () => {
  const [submitted, setSubmitted] = useState(false)
  const FORM_ENDPOINT = 'https://formspree.io/f/mayddbyj'

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        setSubmitted(true);
        form.reset();
        setTimeout(() => {
          setSubmitted(false);
        }, 5000);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <section
      className="paralax-mf footer-paralax bg-image sect-mt4 route"
      style={{
        backgroundImage:
          'url(https://c1.wallpaperflare.com/path/14/432/956/laptop-computer-dark-room-a8ce414d6547f4c4a289489b37843e8b.jpg',
      }}
    >
      <div className="overlay-mf" />

      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="contact-mf">
              <div id="contact" className="box-shadow-full">
                <div className="row">
                  <div className="col-md-6">
                    <div className="title-box-2">
                      <h5 className="title-left">Send A Message</h5>
                    </div>
                    <div>
                      {!submitted && (
                        <form
                          onSubmit={handleSubmit}
                          className="contactForm"
                          id="form"
                        >
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  id="name"
                                  placeholder="Your Name"
                                  data-rule="minlen:4"
                                  data-msg="Please enter at least 4 chars"
                                />
                                <div className="validation" />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  id="email"
                                  placeholder="Your Email"
                                  data-rule="email"
                                  data-msg="Please enter a valid email"
                                />
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="subject"
                                  id="subject"
                                  placeholder="Subject"
                                  data-rule="minlen:4"
                                  data-msg="Please enter at least 8 chars of subject"
                                />
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <textarea
                                  className="form-control"
                                  name="message"
                                  rows="5"
                                  data-rule="required"
                                  data-msg="Please write something for us"
                                  placeholder="Message"
                                ></textarea>
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="button button-a button-big button-rouded"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </form>
                      )}
                      {submitted && (
                        <div id="response-container">
                          <div className="center mt-2">
                            <div className="title-box-2">
                              <h4>Thanks for the message!</h4>
                              <p>Thank you for reaching out. I'll get back to you as soon as possible!</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* SECOND SECTION */}
                  <div className="col-md-6">
                    <div className="title-box-2 pt-4 pt-md-0">
                      <h5 className="title-left">Get in Touch</h5>
                    </div>
                    <div>
                      <p>
                        Looking for a creative UX designer or Frontend Developer? <br />
                        Contact me for more information on how I can help your team.
                      </p>
                      <ul className="list-ico">
                        <li>
                          <span className="ion-ios-location" /> Uppsala, Sweden
                        </li>
                        <li>
                          <span className="ion-social-whatsapp" />
                          <a
                            href="tel:+46737152378"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            (+46) 737152378
                          </a>
                        </li>
                        <li>
                          <span className="ion-email" />
                          <a
                            href="mailto:alladin.daher@hotmail.com"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            alladin.daher@hotmail.com
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="socials">
                      <ul>
                        <li>
                          <a
                            href="https://github.com/AD757"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span className="ico-circle">
                              <i className="ion-social-github" />
                            </span>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://linkedin.com/in/alladin-daher-404a92117"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span className="ico-circle">
                              <i className="ion-social-linkedin" />
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="copyright-box">
                <p className="copyright">
                  &copy; {new Date().getFullYear()} &lt; <strong>Alladin Daher</strong>{' '}
                  &#47;&gt;
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
  )
}

export default Contact